import React, {Component} from 'react';
import {connect} from 'react-redux'
import { Button, FormControl, Row, Col, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import StockStore from 'stores/StockStore'
import ConfirmPopup from 'component/element/ConfirmPopup'
import './Stock.css';
var NotificationSystem = require('react-notification-system');

class StockTyreEditCategoryModal extends Component {

  constructor(...args) {
    super(...args)
    this.state = {data:[] ,deleteShow:false,indexDelete:-1}
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps) {
      if (newProps.show&&newProps.show!==this.props.show) {
            this.loadData()
      }
  }

  getData(){
    let {data} = this.state
    return data
  }

  loadData(){
    let that = this
    let {catId,cateAdd} = this.props
    if (cateAdd==='cat_id') {
      StockStore.loadCategory(this.props.stockType,function(result) {
        that.setState({data: result.data})
      })
    } else if ('sub_cat_id') {
      StockStore.loadSubCategory(this.props.stockType,catId,function(result) {
        that.setState({data: result.data})
      })
    }  
  }

  onNewItemClick(){
    let {data} = this.state
    data.push({name:'',stock_type:this.props.stockType,parent_id:0,cat_id:0,edit:true})
    this.setState({data:data})
  }

  onEditItemClick(index){
    let {data} = this.state
    data[index].edit = true
    this.setState({data:data})
  }

  onConfirmCatDelete(){
    let {messages,cateAdd} = this.props
    let {indexDelete,data} = this.state
    let that = this
    if(data[indexDelete].cat_id>0){
      let cat_id = data[indexDelete].cat_id
      StockStore.deleteCategory(data[indexDelete].cat_id,function(result) {
        
        data.splice(indexDelete,1);  
        that.setState({data:data,deleteShow:false})  
        if (cateAdd==='cat_id'&&that.props.onNewCategory!==undefined)
          that.props.onNewCategory(cat_id)
        else if (cateAdd==='sub_cat_id'&&that.props.onNewSubCategory!==undefined)
          that.props.onNewSubCategory(cat_id)  
      },function(){
        that._notificationSystem.addNotification({
          title:messages['Notification'],
          message: messages['Remove Category Failed, Please Try Again'],
          level: 'error',
          position:'tc'
        });
      })
    }else{
      data.splice(indexDelete,1);  
      that.setState({data:data,deleteShow:false}) 
    }
  }

  onDeleteItemClick(index){
    let {data} = this.state
    let {messages} = this.props
    if(data[index].edit){
      data.splice(index,1);  
      this.setState({data:data})
    }else{
      this.setState({indexDelete:index,deleteShow:true,deleteMsg:messages['Want To Delete Category']+' ['+data[index].name+'] '+messages['Left Out']})
    }
  }

  onItemChange(index,e){
    let {data} = this.state
    data[index].name = e.target.value
    this.setState({data:data})
  }

  render() {
    let {data,deleteShow,deleteMsg} = this.state
    let {messages,cateAdd,show} = this.props
    return (
      <div>
        <Modal show={show} onHide={this.props.onHide} bsSize="large">
            <Modal.Header closeButton>
                <Modal.Title>{cateAdd==='cat_id'?messages['Add Category']:messages['Add Category']+'ย่อย'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='table-responsive'>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                            <th style={{width:'250px'}}>{cateAdd==='cat_id'?messages['Category']:messages['Category']+'ย่อย'}</th>
                            <th style={{width:'100px'}}>{messages['Edit/Delete']}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length===0?<tr><td colSpan={2}>ไม่พบข้อมูล</td></tr>:data.map((item,index)=>(
                            <tr key={index}>
                                <td>
                                <FormControl type="text" 
                                    value={item.name} 
                                    readOnly={item.edit!==undefined?!item.edit:true} 
                                    onChange={this.onItemChange.bind(this,index)}
                                    className="input-dark" 
                                />
                                </td>
                                <td className="text-center">
                                <Row>                    
                                    <Col md={12}>
                                    <Button className="btn-danger" onClick={this.onDeleteItemClick.bind(this,index)}>
                                    <FontAwesome name='trash' /> {messages['Delete']}
                                    </Button>
                                    </Col>
                                </Row>  
                                </td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                </div>  
                <div style={{marginTop:'10px'}}>
                  <Button className="btn-success" onClick={this.onNewItemClick.bind(this)}>
                    <FontAwesome name='plus' /> {messages['Add Item']}
                  </Button>
                </div>  
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-primary" onClick={this.props.onCategorySaveClick}>
                    <FontAwesome name='save' /> {cateAdd==='cat_id'?'บันทึกหมวดหมู่':'บันทึกหมวดหมู่ย่อย'}
                </Button>
                <Button onClick={this.props.onHide}>
                    <FontAwesome name='close' /> ปิด
                </Button>
            </Modal.Footer>
        </Modal>    
        <NotificationSystem ref="notificationSystem" />
        <ConfirmPopup show={deleteShow} 
            title={messages['Confirm']} 
            message={deleteMsg}
            confirmTitle={messages['Confirm']}
            onConfirm={this.onConfirmCatDelete.bind(this)}
            onHide={()=>{this.setState({deleteShow:false})}}        
        />
      </div>
    )
  }
}

export default StockTyreEditCategoryModal = connect(
  (state) => ({messages: state.message.view.tyre.stock.StockTyreEditCategoryModal}),null,null,{withRef:true}
)(StockTyreEditCategoryModal);



// WEBPACK FOOTER //
// ./src/view/tyre/stock/StockTyreEditCategoryModal.js